app.mapsController = app.mapsController || {};

app.mapsController.defaultAction = {

    /**
     * Initialisation de la fonction
     */
    init : function () {
        this.contactMap();
    },

    style : function () {
        return [
            {
                "featureType": "all",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 0
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "all",
                "stylers": [
                    {
                        "invert_lightness": true
                    },
                    {
                        "saturation": -100
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#00bcb4"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#00bcb4"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#454545"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    },
                    {
                        "color": "#000000"
                    }
                ]
            }
        ];
    },

    contactMap : function () {
        if($('#gMap').length) {

            var myLatlng = new google.maps.LatLng(48.629638, -2.009890);
            var myOptions = {
                disableDefaultUI: true,
                zoomControl: true,
                zoomControlOptions: {
                    style: google.maps.ZoomControlStyle.SMALL
                },
                draggable: $('html').hasClass('no-touch'),
                scrollwheel: false,
                zoom: 12,
                styles: this.style(),
                center: myLatlng,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };
            var map = new google.maps.Map(document.getElementById("gMap"), myOptions);
            var marker = new google.maps.Marker({
                position: myLatlng,
                map: map,
                title: "Le Saint Placide : 6, place du Poncel, 35400 Saint-Malo",
                icon:'/content/themes/saint-placide/img/marker.png'
            });
            var infowindow = new google.maps.InfoWindow({
                content: "<p><strong>Le Saint Placide</strong><br />6, place du Poncel<br />35400 Saint-Malo</p>"
            });
            google.maps.event.addListener(marker, 'click', function() {
                infowindow.open(map, marker);
            });
        }
    }

};

$(document).ready(function(){
    app.mapsController.defaultAction.init();
});
